"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchYtjClear = exports.setSearchString = exports.searchYtjFailed = exports.searchYtjSuccess = exports.searchYtjRequest = void 0;
const Actions = require("../../actionTypes/customer/ytj");
const searchYtjRequest = (searchString) => ({
    type: Actions.SEARCH_YTJ_REQUEST,
    payload: {
        searchString
    }
});
exports.searchYtjRequest = searchYtjRequest;
const searchYtjSuccess = (companies) => ({
    type: Actions.SEARCH_YTJ_SUCCESS,
    payload: {
        companies
    }
});
exports.searchYtjSuccess = searchYtjSuccess;
const searchYtjFailed = (error) => ({
    type: Actions.SEARCH_YTJ_FAILED,
    payload: error
});
exports.searchYtjFailed = searchYtjFailed;
const setSearchString = (searchString) => ({
    type: Actions.SET_YTJ_SEARCH_STRING,
    payload: {
        searchString
    }
});
exports.setSearchString = setSearchString;
const searchYtjClear = () => ({
    type: Actions.SEARCH_YTJ_CLEAR
});
exports.searchYtjClear = searchYtjClear;
//# sourceMappingURL=ytj.js.map